import { render, staticRenderFns } from "./ProofReturn.vue?vue&type=template&id=244a16cb&scoped=true"
import script from "./ProofReturn.vue?vue&type=script&lang=js"
export * from "./ProofReturn.vue?vue&type=script&lang=js"
import style0 from "./ProofReturn.vue?vue&type=style&index=0&id=244a16cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244a16cb",
  null
  
)

export default component.exports